<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead"><a id="page_v"></a><a id="a7"></a>Contents</h1>
<h2 class="toc"><a id="ncx42"></a><a href="#/xhtml/07_Chapter_1#a24">Author’s Notes and Acknowledgements</a></h2>
<h2 class="toc"><a id="ncx43"></a><a href="#/xhtml/08_Chapter_2#a25">Profiles</a></h2>
<h2 class="toc"><a id="ncx44"></a><a href="#/xhtml/09_Chapter_3#a26">C Squadron SAS</a></h2>
<h2 class="toc"><a id="ncx45"></a><a href="#/xhtml/10_Chapter_4#a27">Rebuilding</a></h2>
<h2 class="toc"><a id="ncx46"></a><span href="#/xhtml/11_Chapter_5#a28" title="Link target outside of Sample">Escape and Evasion</span></h2>
<h2 class="toc"><a id="ncx47"></a><span href="#/xhtml/12_Chapter_6#a29" title="Link target outside of Sample">Getting the Boot</span></h2>
<h2 class="toc"><a id="ncx48"></a><span href="#/xhtml/13_Chapter_7#a30" title="Link target outside of Sample">The Ghosts of Angola</span></h2>
<h2 class="toc"><a id="ncx49"></a><span href="#/xhtml/14_Chapter_8#a31" title="Link target outside of Sample">Haunting the MPLA</span></h2>
<h2 class="toc"><a id="ncx50"></a><span href="#/xhtml/15_Chapter_9#a32" title="Link target outside of Sample">Relentless Pursuit</span></h2>
<h2 class="toc"><a id="ncx51"></a><span href="#/xhtml/16_Chapter_10#a33" title="Link target outside of Sample">The Anguish of an SAS General</span></h2>
<h2 class="toc"><a id="ncx52"></a><span href="#/xhtml/17_Chapter_11#a34" title="Link target outside of Sample">The British Reply to General Wall’s Letter</span></h2>
<h2 class="toc"><a id="ncx53"></a><span href="#/xhtml/18_Chapter_12#a35" title="Link target outside of Sample">A Tribute to General Peter Walls</span></h2>
<h2 class="toc"><a id="ncx54"></a><span href="#/xhtml/19_Chapter_13#a36" title="Link target outside of Sample">South Africa’s Zimbabwe Flop</span></h2>
<h2 class="toc"><a id="ncx55"></a><span href="#/xhtml/20_Chapter_14#a37" title="Link target outside of Sample">Renamo Gather Steam</span></h2>
<h2 class="toc"><a id="ncx56"></a><span href="#/xhtml/21_Chapter_15#a38" title="Link target outside of Sample">The Assassination of Samora Machel?</span></h2>
<h2 class="toc"><a id="ncx57"></a><span href="#/xhtml/22_Chapter_16#a39" title="Link target outside of Sample">The Grahams of Burnley</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?347c144e